module.exports = __webpack_public_path__ + "img/2024_S.8ad76acd.png";